export default __webpack_public_path__ + "static/media/D_wdt_c_cap_3.627ab719.mp3";